import gql from 'graphql-tag';

const BANNERS_QUERY = gql`
  query getBanners {
    getBanners {
      background_image
      heading
      subheading
      link
      button_text
      show_button
    }
  }
`;

export default BANNERS_QUERY;



// WEBPACK FOOTER //
// ./src/graphql/queries/banners.query.js